"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.EnterCodeOverlay = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactApollo = require("react-apollo");
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _enterCode = _interopRequireDefault(require("./enter-code"));
// eslint-disable-next-line import/prefer-default-export
var EnterCodeOverlay = function EnterCodeOverlay(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloConsumer, null, function (client) {
    return /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: true
    }, /*#__PURE__*/_react["default"].createElement(_enterCode["default"], (0, _extends2["default"])({}, props, {
      client: client
    })));
  });
};
exports.EnterCodeOverlay = EnterCodeOverlay;
EnterCodeOverlay.displayName = 'EnterCodeOverlay';